import React, { useState } from "react";
import { useToast, VStack, Button, Icon } from "@chakra-ui/react";
import LogoWordMark from "../Assets/LogoWordMark";
import { useAuth } from "../Contexts/AuthContext";
import { FcGoogle } from "react-icons/fc";

const Login = () => {
  const { signInWithPopupGoogle, getAuthErrorMessage } = useAuth();
  const toast = useToast();
  const [isLoading, setisLoading] = useState(false);

  const googleHandler = () => {
    //google sign in
    setisLoading(true);
    return signInWithPopupGoogle()
      .then(result => {
        console.log("google logged in");
      })
      .catch(error =>
        toast({
          description: getAuthErrorMessage(error.code),
          status: "error",
        })
      )
      .finally(() => setisLoading(false));
  };

  return (
    <VStack spacing={12}>
      <LogoWordMark w="120px" />
      <Button
        w="full"
        borderRadius="8px"
        fontSize="14px"
        variant="outline"
        leftIcon={<Icon as={FcGoogle} w={5} h={5} />}
        onClick={googleHandler}
        isLoading={isLoading}
      >
        Continue with Google
      </Button>
    </VStack>
  );
};

export default Login;
